
<form class="modal-body" #form="ngForm">
  <div class="form-group">
    <div class="btn-group btn-group-justified d-flex">
      <input class="btn-check" type="radio" [(ngModel)]="type" value="anonymous" name="typeAnonymous" id="typeAnonymous">
      <label class="btn btn-outline-secondary no-wrap" [class.active]="type === &quot;anonymous&quot;" for="typeAnonymous"><span translate>Anonymous</span></label>
      <input class="btn-check" type="radio" [(ngModel)]="type" value="email" name="typeEmail" id="typeEmail">
      <label class="btn btn-outline-secondary no-wrap" [class.active]="type === &quot;email&quot;" for="typeEmail"><span translate>E-mail</span></label>
      <input class="btn-check" type="radio" [(ngModel)]="type" value="user" name="typeUser" id="typeUser">
      <label class="btn btn-outline-secondary no-wrap" [class.active]="type === &quot;user&quot;" for="typeUser"><span translate>Existing user</span></label>
    </div>
  </div>
  <div class="form-group" *ngIf="type == &quot;email&quot;">
    <input class="form-control" type="email" required [(ngModel)]="email" name="email" [placeholder]="&quot;E-mail&quot;|translate" id="createCloudLinkModal-email" label>
  </div>
  <div class="form-group" *ngIf="type == &quot;user&quot;">
    <select class="form-control" [(ngModel)]="email" name="user" required *ngIf="users">
      <option value="" translate>Select a user</option>
      <option *ngFor="let x of users|naturalOrderBy:&quot;displayName&quot;" [ngValue]="x.email">{{x.displayName + " (" + x.email + ")"}}</option>
    </select>
  </div>
  <div class="form-group">
    <label translate for="createCloudLinkModal-limit">Limit views</label>
    <input class="form-control" type="number" min="1" step="1" name="limit" [placeholder]="&quot;Unlimited&quot;|translate" id="createCloudLinkModal-limit" [(ngModel)]="viewLimit">
  </div>
  <div class="form-group" *ngIf="identity.user?.email || type != &quot;anonymous&quot;">
    <label>Notification</label>
    <div *ngIf="identity.user?.email">
      <checkbox [(ngModel)]="notifyOnUse" name="notifyOnUse" text="{{&quot;Notify me when the link is clicked&quot;|translate}}"></checkbox>
    </div>
    <div *ngIf="type != &quot;anonymous&quot;">
      <checkbox [(ngModel)]="sendEmail" name="sendEmail" text="{{&quot;E-mail the link to user once the upload is complete&quot;|translate}}"></checkbox>
    </div>
  </div>
</form>
<div class="modal-footer">
  <button class="btn btn-outline-primary" [clickBlocking]="create" [disabled]="!form.form.valid" translate>Create link</button>
  <button class="btn btn-outline-secondary" (click)="cancel()" translate>Cancel</button>
</div>